module.exports = __webpack_public_path__ + "img/icon-transfer.4bb5586f.svg";